import React from 'react';
import classes from './ResourceCard.module.scss';
import {
  CONNECTION_CATEGORY_DATABASE,
  CONNECTION_CATEGORY_FILE,
} from 'js/constants/connectionCategories';
import isEmpty from 'lodash/isEmpty';
import Typography from 'new/elements/TypographySupport/TypographySupport';
import { useGetSourceMetaByID } from 'new/hooks/useGetSourceMetaByID';
import flowTypes from 'new/components/flows/types/flowTypes';
import { ReactComponent as CodeContainerIcon } from 'new/components/icons/CodeContainerIcon.svg';
import { ReactComponent as LookUpIcon } from 'new/components/icons/lookUpResourceIcon.svg';
import { ReactComponent as CredentialIcon } from 'new/components/icons/credentialResourceIcon.svg';
import {
  RESOURCE_TYPE_CREDENTIALS,
  RESOURCE_TYPE_DATA_MAP,
  RESOURCE_TYPE_RECORD_TRANSFORM,
} from 'js/constants/resourceTypes';
import { ConnectionTypeChip } from 'new/elements/ConnectionTypeChip/ConnectionTypeChip';
import classNames from 'classnames';

const resourceTypeIcons = {
  [RESOURCE_TYPE_RECORD_TRANSFORM]: <CodeContainerIcon />,
  [RESOURCE_TYPE_DATA_MAP]: <LookUpIcon />,
  [RESOURCE_TYPE_CREDENTIALS]: <CredentialIcon />,
};

export const TopContent = (props: any) => {
  const {
    data,
    resourceType,
    flowType,
    connectionInfo,
    selectActions,
    rootConnectionInfo,
    connectionOrVendorType,
    shouldUseResourceIcon,
    isPreview,
    readOnly,
    isManaged,
    aclQueryMode,
    isNodeDiscoveryEnabled,
    isDataFlowStatus,
  } = props;
  const { type, flow_type } = data;
  const sourceMeta = useGetSourceMetaByID(data.id);
  let showTransform = props.showTransform;

  if (
    (flowType === flowTypes.replication &&
      [CONNECTION_CATEGORY_FILE, CONNECTION_CATEGORY_DATABASE].includes(
        rootConnectionInfo?.connectionCategory,
      ) &&
      !isEmpty(data.children)) ||
    flow_type === 'cdc' ||
    flow_type === 'elt'
  ) {
    showTransform = false;
  }

  const sourceIcon = (() => {
    if (shouldUseResourceIcon) {
      const icon = resourceTypeIcons[resourceType];
      if (icon) {
        return icon;
      }
    }
    if (sourceMeta) return sourceMeta.iconSm;
    if (connectionInfo) return connectionInfo.iconSm;
    return null;
  })();

  const sourceName = (() => {
    if (sourceMeta?.name) return sourceMeta.name;
    if (connectionInfo) return connectionInfo.name;
    return connectionOrVendorType;
  })();

  const nameWithoutEmptySpaces = data.name?.replace(/\s/g, '');
  const isNameSingleLine = isNodeDiscoveryEnabled || isDataFlowStatus;

  return (
    <>
      <div className={classes.resourceInfo}>
        <div className={classes.icon}>
          <ConnectionTypeChip
            icon={sourceIcon}
            isNexset={type === 'DATA_SET'}
            isSplitter={data.node_type === 'splitter'}
            iconOnly
            style={{ border: 'none', padding: 0 }}
          />
        </div>
        <div className={classes.name}>
          <Typography
            className={classNames(
              classes.resourceName,
              isNameSingleLine && classes.resourceNameSingleLine,
            )}
            variant="subtitle2"
            data-testid={`top-content-name-${data.id}`}
          >
            {data.name}
          </Typography>
        </div>
      </div>
    </>
  );
};
